import type { ContractingCaseStatusFilter } from '~/types/services/contracting';

export const CASES_LABEL = 'Campaign Operation Cases';
export const CASES_PATH = '/commercial-ops/flash-reporting/campaign-cases';
export const CAMPAIGN_OPS_TEAM_KEY = 'campaign_ops';

export const CASE_STATUS_FILTERS: ReadonlyArray<{ value: ContractingCaseStatusFilter; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'open', label: 'Open only' },
  { value: 'closed', label: 'Closed only' },
];
export const DEFAULT_CASE_STATUS_FILTER: ContractingCaseStatusFilter = 'open';

export function casePath(caseNumber: string): string {
  return `${CASES_PATH}/${caseNumber}`;
}
